/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaginatedResultOfTrashItemResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaginatedResultOfTrashItemResponse } from '../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /trash
 */
export interface TrashRequestBuilder extends BaseRequestBuilder<TrashRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaginatedResultOfTrashItemResponse>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<TrashRequestBuilderGetQueryParameters> | undefined) : Promise<PaginatedResultOfTrashItemResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TrashRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface TrashRequestBuilderGetQueryParameters {
    kinds?: string;
    page?: number;
    pageSize?: number;
}
/**
 * Uri template for the request builder.
 */
export const TrashRequestBuilderUriTemplate = "{+baseurl}/trash{?kinds*,page*,pageSize*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const TrashRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TrashRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPaginatedResultOfTrashItemResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
